export const LINES = {
  DOT: 'dot',
  DASH: 'dash',
  SOLID: 'solid',
  GRADIENT: 'gradient',
}
